import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider } from '@material-ui/core/styles'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import * as Pages from './pages/index'
import PageContainer from './shared/PageContainer'
import Layout from './layout'
import { loadUser } from './redux/actions/User.actions'
import theme from './theme'
import 'antd/dist/antd.css'

import PrivateRoute from './routes/PrivateRoute'

import Loader from './shared/Loader'

// Nothing in this portal ever writes `localStorage.token` — signing in sets an
// httpOnly session cookie, which the browser sends on its own and script cannot
// read. The two places that read that key, here and in `loadUser`, were reading
// a value that is never there, so the `Authorization` header they set up was
// never set up. Removed rather than left looking load-bearing.

const App = () => {
  const dispatch = useDispatch()

  const { loading, isAuthenticated } = useSelector((state) => state.user)

  // redux-persist keeps the signed-in state in localStorage, so it outlives the
  // browser being closed — while the session cookie behind it may not. Nothing
  // checked, so the portal let an admin in on a stale flag and then failed
  // every request it made.
  //
  // Asked only when something already claims to be signed in: on a fresh
  // browser there is nothing to check, and asking anyway would greet a stranger
  // on the login page with "Invalid authentication".
  // Once, on load: whatever this finds is what the rest of the session goes on,
  // and re-running it as the flag changes would answer its own question.
  useEffect(() => {
    if (isAuthenticated) dispatch(loadUser())
  }, [])

  const DefaultContainer = () => (
      <Layout>
        <Switch>
          <Route exact path='/dashboard' component={Pages.DashboardPage} />

          <Route exact path='/members' component={Pages.MembersPage} />
          <Route exact path='/requests' component={Pages.DeletionRequestsPage} />
          <Route exact path='/pendings' component={Pages.PendingsPage} />
          <Route
              exact
              path='/members/:memberId'
              component={Pages.MemberDetailsPage}
          />
          <Route
              exact
              path='/members/:memberId/memberships/:membershipId'
              component={Pages.MembershipDetailsPage}
          />

          <Route
              exact
              path='/prospective-members'
              component={Pages.ProspectiveMembersPage}
          />

          <Route exact path='/reports' component={Pages.Reports} />

          <Route component={Pages.Error404Page} />
        </Switch>
      </Layout>
  )

  return (
      <ThemeProvider theme={theme}>
        <PageContainer>
          {loading ? (
              <Loader />
          ) : (
              <Router>
                <Switch>
                  <Route exact path='/' component={Pages.LoginPage} />
                  <Route exact path='/login' component={Pages.LoginPage} />
                  <PrivateRoute component={DefaultContainer} />
                  <Route component={Pages.Error404Page} />
                </Switch>
              </Router>
          )}
        </PageContainer>
      </ThemeProvider>
  )
}
export default App
